<template>
  <div class="w">
    <div class="center">
      <div class="datails_nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <i class="el-icon-s-home" />首页
          </el-breadcrumb-item>

          <el-breadcrumb-item v-show="inde == 4" :to="{ path: '/Assume' }">揭榜挂帅</el-breadcrumb-item>

          <el-breadcrumb-item v-show="inde != 4">通知·资讯</el-breadcrumb-item>

          <el-breadcrumb-item v-if="inde == 4">相关通知</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="tong" v-show="CloseTab">
        <div
          v-for="(item, n) in tongzhi"
          :key="n"
          @click="tongCli(n,item.name)"
          :class="inde == n ? 'tback' : ''"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <!--  -->
      <div class="relevant">
        <div class="new">
          <div class="item" v-for="(i, n) in dataList" @click="openNewInfo(i)" :key="n">
            <div class="totle">
              <b>{{ i.CreateTime.substring(8, 10) }}</b>
              <div class="totledate-bottom">
                <p>{{ i.CreateTime.substring(0, 7).replace("-", "年") }}月</p>
              </div>
            </div>
            <div class="content">
              <b class="bbold">{{ i.Titile }}</b>
              <div class="con-div">{{ i.ShortDetails }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pagination
      :limit.sync="searchForm.size"
      :page.sync="searchForm.page"
      :total="total"
      @pagination="loadDatas"
    />
  </div>
</template>
<script>
import { getAction, postAction } from '@/api/api'
import qs from 'qs'
import { xingwend, TypeList, NewsList } from '@/api/url'
import Pagination from '../library/components/Pagination/index.vue'
import $ from '../../../public/jquery-2.1.1.js'
export default {
  components: { Pagination },
  data() {
    return {
      tongzhi: [
        { name: '通知公告' },
        { name: '政策资讯' },
        { name: '产经资讯' },
      ],
      navName:'',
      inde: 0,
      CloseTab: true,
      total: 0,
      type: 0,
      dataList: [],
      searchForm: {
        action: 'Get_ZBInformationListByPage',
        pageSize: 10, //一页多少条
        page: 1, //	第几页
        Type: 3,
      },
    }
  },
  created() {
    //// console.log(this.$route.query.type);
    this.type = this.$route.query.type
    this.inde = this.$route.query.type
    if (this.type == 4) {
      this.CloseTab = false
      this.loadData()
    } else {
      this.loadNews(this.type)
    }
  },
  methods: {
    tongCli(n,name) {
      if(name !== this.navName){
        this.navName = name
        this.searchForm.page = 1
      }
      this.inde = n
      this.type = n
      this.loadNews(n)
    },
    navigation(){
      console.log(33333)
    },
    loadNews(type) {
      if (type == 0) {
        this.searchForm.action = 'Get_InformationList'
        this.searchForm.Type = 4
        postAction(NewsList, this.$qs.stringify(this.searchForm)).then(
          (res) => {
            //// console.log(res.count);
            this.total = res.count
            this.dataList = res.data
          }
        )
      } else {
        if(type ==1)
        {
          type =2;
        }
        else if(type ==2)
        {
          type =1;
        }
        let vm = this;
      let data = {
        action: "Get_InformationTzgg",
        Type:type,
        Count: "7",
        limit: 10,
        skip: vm.searchForm.page,
        region: '',
        q: ''
      };

      postAction(NewsList, this.$qs.stringify(data)).then((res) => {
        console.log("日志 + " + res.count)
        vm.dataList = []
        vm.total = res.count
        vm.dataList = res.data;
        console.log("日志 + " + res.data)
        console.log("日志 + 结束" )
      });
      }
    },
    loadData() {
      postAction(TypeList, this.$qs.stringify(this.searchForm)).then((res) => {
        //// console.log(res);
        this.total = res.count
        this.dataList = res.data
      })
    },
    loadDatas() {
      if (this.type == 4) {
        this.CloseTab = false
        this.loadData()
      } else {
        this.loadNews(this.type)
      }
    },
    openNewInfo(i) {
        //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        let routeData = this.$router.resolve({
        path: '/NewsInfo',
        query: { type: this.type, id: i.ID },
      })
      window.open(routeData.href, '_blank')

      }
      else
      {
          window.location.href=this.Urls+'/Mobile/index.html#/AboutNotice?data=' + i.ID + '&type='+ this.type

      }
   
    },
  },
}
</script>

<style lang='scss' scoped>
body {
  margin: 0rem;
  font-family: Microsoft YaHei;
  left: 0rem;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  box-sizing: border-box;
}
#header {
  height: 7.4375rem;
  border-bottom: 0.0625rem solid #ffffffa9;
  background-color: #222222;
  width: 100%;
}
.w {
  width: 100%;
  height: auto;
  background: url(../../assets/Assume-Image/组23358.png) no-repeat;
  overflow: hidden;
}
.center {
  width: 80rem;
  height: auto;
  margin: 1.875rem auto 0;
}
.datails_nav {
  text-align: left;
  line-height: 5.125rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.datails_nav .layui-breadcrumb a {
  color: #ccc !important;
}
.tong {
  width: 100%;
  height: 3.125rem;
  margin-top: 1.25rem;
  display: flex;
  justify-content: flex-start;
}
.tong div {
  width: 9.5625rem;
  height: 2.875rem;
  text-align: center;
  line-height: 2.875rem;
  color: #333;
  font-size: 1.125rem;
  position: relative;
  background: #fff;
  margin-right: 0.0625rem;
  cursor: pointer;

  font-family: PingFang SC;
}
.tback {
  background-color: #308bec !important;
  color: #ffffff !important;
  border: 0.0625rem solid #308bec !important;
}
::v-deep .tback::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 0.5rem solid transparent;
  border-top: 0.5rem solid #308bec;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
/*  */
.relevant {
  width: 100%;
  margin: 0 !important;
}
.publik {
  text-align: center;
  margin-left: 50%;
  transform: translateX(-25%);
  overflow: hidden;
}
.publik img {
  float: left;
  margin-top: 0.625rem;
}
.publik h1 {
  float: left;
  margin: 0 1.875rem;
  font-size: 2.5rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 3.25rem;
  color: #333333;
  letter-spacing: 0.3125rem;
}
.item {
  height: 7.625rem;
  background: #ffffff;
  border: 0.0625rem solid #e5e5e5;
  opacity: 1;
  margin-top: 2.0625rem;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
}
.searchbox {
  position: relative;
  margin-top: 2.5rem;
  height: 3rem;
}
.search {
  position: absolute;
  right: 0;
  width: 10.5625rem;
  height: 2rem;
  background-color: transparent;
  border: 0.0625rem solid #e6e6e6;
  border-radius: 1.875rem;
  padding-left: 0.625rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 1.0625rem;
  color: #e6e6e6;
  opacity: 1;
}
.search input {
  width: 78%;
  background-color: transparent;
  border: 0;
  opacity: 1;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 1.0625rem;
  color: #999999;
  opacity: 1;
  padding-right: 0.3125rem;
  box-sizing: border-box;
  border-radius: 1.875rem;
  font-size: 0.8125rem;
}
.searchbox img {
  position: absolute;
  top: 0.3rem;
  right: 0.9375rem;
  cursor: pointer;
}
.new {
  margin-top: 1.875rem;
}
.item {
  cursor: pointer;
}
.new:hover {
  box-shadow: 0.3125rem 0.3125rem 0.375rem 0.1875rem #999;
}
.totle {
  width: 6.875rem !important;
  height: 100%;
  text-align: center;
  background: #dbebfc;
}
.totle b {
  font-size: 2rem;
  font-family: PingFang SC;
  font-weight: 600;
  line-height: 1.5rem;
  color: #0568be;
  margin: 1.875rem 0 1.5rem;
  display: block;
}
.totledate-top {
  width: 100%;
  height: 3rem;
  line-height: 3.75rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 0.1875rem 0.1875rem 0rem 0rem;
}
.totledate-top span {
  color: rgb(255, 255, 255);
  font-weight: 400;
  font-size: 1.625rem;
}
.totledate-bottom {
  width: 100%;
  height: 1.375rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 0.875rem;
    color: #686f88;
  }
}
.content {
  margin-left: 1.5625rem;
  padding-top: 1.25rem;
  padding-right: 1.25rem;
  line-height: 1.375rem;
  text-align: left;
  box-sizing: border-box;
  width: 71.25rem;
}
.content b {
  display: block;
  text-align: left !important;
  color: #333333;
  font-size: 1.25rem;
  padding-bottom: 0.7rem;
}
.bbold {
  font-weight: bold !important;
}
.con-div {
  width: 100%;
  height: 3rem;
  line-height: 1.6rem;
  font-size: 1rem !important;
  color: #999;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  // display: -webkit-box;
  // font-size: .8125rem;
  // width: 100%;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // color: #999;
}
</style>